import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        const filters = [
            {
                id: 'all',
                value: '',
                label: t('ai_tracking.keyword_detail.all_links.filters.all'),
            },
            {
                id: 'cited',
                value: 'link_type in (1,2)',
                label: t('ai_tracking.keyword_detail.all_links.filters.cited'),
            },
            {
                id: 'considered',
                value: 'link_type in (3,5,6,8,11)',
                label: t('ai_tracking.keyword_detail.all_links.filters.considered'),
            },
            {
                id: 'shopping',
                value: 'link_type in (7,9,10)',
                label: t('ai_tracking.keyword_detail.all_links.filters.shopping'),
            },
            {
                id: 'ads',
                value: 'link_type = 13',
                label: t('ai_tracking.keyword_detail.all_links.filters.ads'),
            },
            {
                id: 'social',
                value: 'link_type = 4',
                label: t('ai_tracking.keyword_detail.all_links.filters.social'),
            },
            {
                id: 'video',
                value: 'link_type = 14',
                label: t('ai_tracking.keyword_detail.all_links.filters.video'),
            },
            {
                id: 'local',
                value: 'link_type = 12',
                label: t('ai_tracking.keyword_detail.all_links.filters.local'),
            },
            {
                id: 'other',
                value: 'link_type = 0',
                label: t('ai_tracking.keyword_detail.all_links.filters.other'),
            },
        ];

        return (
            <>
                <div className="table-additional-view justify-content-bewtween">
                    <div className="table-additional-view-btns ">
                        <div className="table-additional-view-btn-groups">
                            {filters.map((filter) => (
                                <button
                                    key={filter.id}
                                    className={`${
                                        this.props.selectedFilter === filter.id ? 'active' : ''
                                    }`}
                                    onClick={() => this.props.onChangeFilter(filter)}
                                >
                                    {filter.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(AdditionalBox);
